<template>
  <div>
    <ModalCasoAvaliacao ref="casoAvaliacao" :casoId="casoId" :avaliacao="avaliacao"/>
    <div class="comp-star">
      <!-- <a href="#" data-toggle="modal" data-target="#modalCompartilhar"><i class="fas fa-share-alt" data-toggle="tooltip" data-placement="bottom" title="Compartilhar"></i></a> -->
      <div class="star-rating ml-2" >
        <input @click="modalAvalicao(5)" type="radio" id="5-stars" name="rating" />
        <label for="5-stars" class="star"><i class="fas fa-star"></i></label>
        <input @click="modalAvalicao(4)" type="radio" id="4-stars" name="rating" />
        <label for="4-stars" class="star"><i class="fas fa-star"></i></label>
        <input @click="modalAvalicao(3)" type="radio" id="3-stars" name="rating" />
        <label for="3-stars" class="star"><i class="fas fa-star"></i></label>
        <input @click="modalAvalicao(2)" type="radio" id="2-stars" name="rating" />
        <label for="2-stars" class="star"><i class="fas fa-star"></i></label>
        <input @click="modalAvalicao(1)" type="radio" id="1-stars" name="rating" />
        <label for="1-stars" class="star"><i class="fas fa-star"></i></label>
      </div>
    </div>
  </div>
</template>

<script>
import ModalCasoAvaliacao from '@/modules/Jaleklinico/components/ModalCasoAvaliacao'

export default {
  name: 'CasoAvaliacao',
  props: {
    casoId: Number
  },
  components: {
    ModalCasoAvaliacao
  },
  data () {
    return {
      avaliacao: 0
    }
  },
  methods: {
    modalAvalicao: function (avaliacao) {
      this.avaliacao = avaliacao
      this.$nextTick(() => {
        this.$refs.casoAvaliacao.show()
      })
    }
  }
}
</script>
